import { FormState } from '../types';

// Helper function to prepare development report content
export const prepareDevelopmentReport = (formData: FormState['formData']) => {
  // If student is absent, return a simple string instead of JSON
  if (formData.learning_status === "น้องไม่เข้าเรียน (ลากะทันหัน)") {
    return "นักเรียนไม่เข้าเรียน";
  }
  
  // Otherwise, create a JSON with all development-related fields
  return JSON.stringify({
    topic_learned: formData.topic_learned || '',
    knowledge_rating: formData.knowledge_rating || '',
    knowledge_behavior: formData.knowledge_behavior || '',
    skills_rating: formData.skills_rating || '',
    skills_behavior: formData.skills_behavior || '',
    attitude_rating: formData.attitude_rating || '',
    attitude_behavior: formData.attitude_behavior || '',
    student_improvement: formData.student_improvement || '',
    problems_encountered: formData.problems_encountered || [],
    problems_encountered_other: formData.problems_encountered_other || '',
    solutions_applied: formData.solutions_applied || [],
    solutions_applied_other: formData.solutions_applied_other || ''
  });
};
